import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const getTimeZones = createApiThunk<TimeZone[], void>({
  action: 'timeZones',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_TIMEZONES,
})
